import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import PageWrapper from "../SignupPages/PageWrapper";
import rectangleGraph from "../../assets/images/Rectangle-graph.png";
import "../SignupPages/SignupCommon.css";
import CustomStepper from "./Stepper";

const NewSignupPage4: React.FC = () => {
  const [selectedOption, setSelectedOption] = useState<string>("");
  const navigate = useNavigate();
  const location = useLocation(); // ✅

  // ✅ Prevent GTM duplicate historyChange events
  const safeNavigate = (path: string) => {
    if (location.pathname !== path) {
      navigate(path, { replace: true });
    }
  };

  useEffect(() => {
    const step3Completed = localStorage.getItem("step-3-completed");
    if (step3Completed) {
      safeNavigate("/getting-started/step-4");
    } else {
      safeNavigate("/getting-started/step-3");
    }
  }, []);

  const handleOptionClick = (option: string) => {
    setSelectedOption(option);
  };

  const handleNext = () => {
    if (selectedOption) {
      localStorage.setItem(
        "previous_medication_duration",
        JSON.stringify({
          key: "previous_medication_duration",
          value: selectedOption,
          id: 18026060,
        })
      );
    }
    localStorage.setItem("step-4-completed", "true");
  };

  useEffect(() => {
    const savedPreviousMedicationDuration = localStorage.getItem(
      "previous_medication_duration"
    );

    if (savedPreviousMedicationDuration) {
      const parsedPreviousMedicationDuration = JSON.parse(
        savedPreviousMedicationDuration
      );
      setSelectedOption(parsedPreviousMedicationDuration.value);
    }
  }, []);

  const options = [
    "I’ve never tried dieting or exercise",
    "Less than 6 months",
    "6-12 months",
    "Several years",
    "My whole life",
  ];
  const handleBack = () => {
    navigate("/getting-started/step-3");
  };

  const isNewFunnelVariant = localStorage.getItem("isNewFunnelVariant") === "true";

  return (
    <PageWrapper onBack={handleBack}>
      <div className="signup-page-container container">
        <CustomStepper activeStep={1} onBack={handleBack} />
        <div className="signup-content">
          <p className="signup-content-header">
            How long have you been trying to lose weight?
          </p>
          <div className="options options-box-contents">
            {options.map((option) => (
              <label
                key={option}
                className={selectedOption === option ? "selected" : ""}
                onClick={() => handleOptionClick(option)}
              >
                {option}
              </label>
            ))}
          </div>
          <Link to="/getting-started/step-5">
            <button
              className="next-btn sticky-btn"
              onClick={handleNext}
              disabled={!selectedOption}
            >
              Continue →
            </button>
          </Link>
          {!isNewFunnelVariant && <div
            style={{ paddingBottom: "20px", marginTop: "-40px" }}
            className="clinical-trails-div"
          >
            <span className="clinical-content">
              In clinical trails, GLP-1 patients{" "}
              <span style={{ fontWeight: "700" }}>
                lost 18% of their body weight.
              </span>
            </span>
            <div className="graphContainer" style={{ marginBottom: "40px" }}>
              <img src={rectangleGraph} alt="Graph" />
            </div>
            <span className="clinical-content clinical-content-text">
              Non-branded medications offer the{" "}
              <span style={{ fontWeight: "700" }}>same active ingredient</span>{" "}
              as Wegovy®, Ozempic®, Zepbound® and Mounjaro® — but at a fraction
              of the price (80% less) and are more consistently available.
            </span>
          </div>}
          
        </div>
      </div>
    </PageWrapper>
  );
};

export default NewSignupPage4;
